import {
  RETRIEVE_SELLER_TRANSACTIONS,
  RETRIEVE_ADMIN_TRANSACTIONS,
  RETRIEVE_TRANSACTIONS,
} from "../actions/types";

const initialState = {
  transaction: [],
  totalTransactionCount: 0,
  adminCoinDetails: {},
  sellerTransaction: [],
  totalSellerTransactionCount: 0,
  adminTransaction: [],
};

const transactionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_TRANSACTIONS:
      return {
        transaction: payload.transactionListInfo,
        totalTransactionCount: payload.count,
        adminCoinDetails: {
          ...state.adminCoinDetails,
          adminTotalCoins: payload.adminTotalCoins,
          adminWithdrawableCoins: payload.adminWithdrawableCoins,
        },
      };
    case RETRIEVE_ADMIN_TRANSACTIONS:
      return {
        adminTransaction: payload.transactionListInfo,
      };
    case RETRIEVE_SELLER_TRANSACTIONS:
      return {
        ...state,
        sellerTransaction: payload.transactionListInfo,
        totalSellerTransactionCount: payload.count,
      };

    default:
      return state;
  }
};

export default transactionReducer;
